export default function() {

  /**
   * Toggle the visibility of a given element and set associated ARIA attribute values.
   * This function is intended to be used on elements with a unique toggle control
   * and which _do not_ necessitate focus trapping.
   */

  document.addEventListener('click', function(event) {

    /**
     * Query the existence of the required data attribute on the clicked element.
     * If the attribute does not exist, stop executing the function.
     */

    const condition = event.target.matches('[data-toggle]');
    if (!condition) { return; }

    /**
     * Query the existence of the target element. If the element does not exist,
     * stop executing the function.
     */

    const toggle = event.target;
    const target = document.querySelector(toggle.dataset.toggle);
    if (!target) { return; }

    /**
     * Query the visibility of the target element.
     */

    const visible = (target.classList.contains('is-visible'));

    /**
     * Set/remove ARIA attribute values according to the visibility of the
     * target element.
     */

    if (visible === false) {
      target.classList.add('is-visible');
      toggle.setAttribute('aria-expanded', true);

      /**
       * If the toggle control is part of a group, find its sibling toggle
       * controls and hide their target elements.
       */

      if (toggle.dataset.toggleGroup) {
        const siblings = document.querySelectorAll(`[data-toggle-group="${toggle.dataset.toggleGroup}"]`);
        if (!siblings) { return; }

        siblings.forEach(function(sibling) {
          if (sibling != toggle) {
            const target = document.querySelector(sibling.dataset.toggle);

            target.setAttribute('aria-hidden', true);
            sibling.setAttribute('aria-expanded', false);
          }
        });
      }
    }

    else {
      target.classList.remove('is-visible');
      toggle.setAttribute('aria-expanded', false);
    }
  });
}
